import { render } from "./VZGlobalFilter.vue?vue&type=template&id=42586997&scoped=true&ts=true"
import script from "./VZGlobalFilter.vue?vue&type=script&lang=ts"
export * from "./VZGlobalFilter.vue?vue&type=script&lang=ts"

import "./VZGlobalFilter.vue?vue&type=style&index=0&id=42586997&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42586997"]])

export default __exports__